import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import _ from 'lodash';

import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import { Add, Remove, Settings } from '@material-ui/icons';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import { setSelectedApp } from '../../../../actions/appsActions';
import {
	clearBreadCrumbLocationArray,
	updateBreadCrumbLocationArray,
	updateScreenName,
} from '../../../../actions/breadCrumbActions';
import { showMessage } from '../../../../actions/globalActions';
import {
	addMediaDetails,
	clearInspectScreenStorage,
	setSidePlayerConfigId,
	updateMenuKeys,
} from '../../../../actions/inspectScreenActions';
import { updateCurentComponentKey } from '../../../../actions/navActions';
import { showNotification } from '../../../../actions/notificationActions';
import { loadPlayerConfiguration } from '../../../../actions/playerConfigurationActions';
import { getAccountSettings } from '../../../../actions/profileActions';
import {
	applyRestrictionRuleOnMedia,
	changeRouteAfterInspectScreen,
	createNewRestrictionRule,
	deleteRestrictionRule,
	deleteRestrictionRuleOnMedia,
	fetchPlayerEmbedConfiguration,
	getMediaQueryDetails,
	saveInspectScreenDetails,
	sendMediaScreenChanged,
	sendMediaScreenUnChanged,
	shareThePostOnSocialMedia,
	updateExistingRestrictionRule,
	loadMediasByQuery,
	setMediaForTrimming,
} from '../../../../actions/publishActions';
import { setIsMountedSubtitleUpdated } from '../../../../actions/speechToTextActions';
import copy_text from '../../../../assets/images/copy_text.svg';
import download_new from '../../../../assets/images/download_new.svg';
import eye_black from '../../../../assets/images/eye_black.svg';
import { ReactComponent as ContentCut } from '../../../../assets/images/ContentCut.svg';
import { a11yLanguages, a11yLanguagesTranslateLabels } from '../../../../constants/languageConstants';
import {
	BONNIER_NEW_PRESET_ID,
	DEFAULT_THEO_PLAYER_EMBED,
	THEO_PLAYER_PRESET_ID,
	mediaNames,
	messageTypes,
	renditionTypes,
} from '../../../../constants/mediaConstants';
import {
	advancedSettingLabels,
	defaultSettingTypes,
	publicConfigIds,
} from '../../../../constants/playerConfigurationsConstant';
import FeaturesService from '../../../../services/FeaturesService';
import {
	defaultStoryVideoHeight,
	defaultStoryVideoWidth,
	defaultVideoHeight,
	defaultVideoWidth,
	sides,
} from '../../../../services/inspectScreenHelperService';
import { generateId, generateRandomId } from '../../../../services/stringHelperService';
import { joinClassNames } from '../../../../services/elementHelperService';
import {
	qplayerDomain,
	qplayerLoaderUrl,
	readPublicApiEndpointV1,
	portalsUrl,
	envName,
	qplayerWebComponentLoaderUrl,
} from '../../../../utils/config';
import InformationSection from './../InspectSections/InformationSection/InformationSection';
import { fetchAccountPortalThemesService } from '../../../../services/portalApiService';
import { INDIVIDUAL_SHARE_PORTAL_ID } from '../../../../constants/portalThemesConstant';
import { checkPermissionGrantedFor } from '../../../../services/componentReusableService';
import ColorHub from '../../../../reusable/ColorHub/ColorHub';
import QbrickEditorDialog from '../../../../reusable/QbrickEditor/QbrickEditorDialog';

import './InspectPlayerPreviewArea.scss';

class InspectPlayerPreviewArea extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mobileView: false,
			mediaDetails: null,
			routeAfterSave: '',
			selectedResourceId: '',
			isSaveInProgress: false,
			mediaName: mediaNames.medias,
			mobileViewZone: sides.left,
			liveMediaChannelId: '',
			lastRoute: '',
			videoWidth: defaultVideoWidth,
			videoHeight: defaultVideoHeight,
			accessToLive: false,
			accessToInteract: false,
			accessToSTT: false,
			playerConfigurationId: 'default',
			liveManagerLoaded: false,
			interactiveManagerLoaded: false,
			startPlayerMuted: false,
			showPlayerSettingOptions: false,
			playerConfigs: [],
			selectedPlayerConfig: null,
			autostart: false,
			replay: false,
			muteAtStart: false,
			playerSize: 'responsive',
			fixedSize: { width: '640', height: '360' },
			videos: [],
			showSocialSharing: false,
			showDownloadButton: false,
			showOpenInNewWindow: false,
			softFullscreen: false,
			defaultPlayerConfigs: [],
			language: '',
			portalLayouts: [],
			selectedPortalLayoutId: null,
			isQuickEditShown: false,
			selectedDivEmbedVersion: '1.1',
			overrideDefaultAspectRatio: false,
			overrideDefaultAspectRatioValue: '16/9',
			reelsUrlPattern: '',
			reelsGalleryUrl: '',
			reelsAdTag: '',
			reelsAdInterval: '',
			reelsAdSkipAfter: '',
			reelsAdvancedOpen: false,
			// Generated once, not per call: getReelsEmbedCode runs for the textarea and again for
			// the copy button, so a fresh id each time meant the code on screen and the code on the
			// clipboard named different feeds - and the example trigger below has to match.
			reelsFeedId: `qplayer-reels-${generateRandomId()}`,
		};
		this.mediaDetailWidget = 'mediaDetail-' + generateId();
		this.mediaDetailContainer = 'mediaDetailContainer-' + generateId();
		this.originPlayerConfig = null;
	}

	componentDidMount() {
		const { getMediaPreviewDialogRef } = this.props;
		this.loadAccountPlayerConfiguration();
		this.loadDefaultPlayerConfigs();
		this.loadPortalsData();
		this.getVideoDownloadData();
		this.initPlayer();
		getMediaPreviewDialogRef && getMediaPreviewDialogRef(this);
	}

	componentDidUpdate(prevProps, prevState) {
		const { selectedPlayerConfig, overrideDefaultAspectRatio } = this.state;
		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;
		const isStoryPreset = selectedPlayerConfig?.id?.toLowerCase().includes(publicConfigIds.Story.toLowerCase());
		const prevIsStoryPreset = prevState.selectedPlayerConfig?.id
			?.toLowerCase()
			.includes(publicConfigIds.Story.toLowerCase());

		if (isStoryPreset && !prevIsStoryPreset && overrideDefaultAspectRatio) {
			this.setState({ overrideDefaultAspectRatio: false });
		}

		const isConfigChange =
			prevState.selectedPlayerConfig !== this.state.selectedPlayerConfig ||
			this.state.showDownloadButton !== prevState.showDownloadButton ||
			this.state.showSocialSharing !== prevState.showSocialSharing ||
			this.state.showOpenInNewWindow !== prevState.showOpenInNewWindow ||
			this.state.muteAtStart !== prevState.muteAtStart ||
			this.state.autostart !== prevState.autostart ||
			this.state.replay !== prevState.replay ||
			this.state.language !== prevState.language;

		if (!this.props.embedOnly && isConfigChange) {
			if (!isUsingTheoPlayer) {
				this.cleanTheoPlayer();
				window.QplayerLoader.killInteractivePlayer?.();
				const element = document.getElementById('player-preview');
				if (element) {
					element.innerHTML = '';
					this.initPlayer();
				}
			} else {
				const script = document.getElementById('theo-script-id');
				if (script) {
					script.remove();
				}
				const newScript = document.createElement('script');
				newScript.setAttribute(
					'src',
					selectedPlayerConfig.layouts[0]?.playerStyling?.script ?? DEFAULT_THEO_PLAYER_EMBED
				);
				newScript.setAttribute('async', true);
				document.head.appendChild(newScript);
			}
		}

		const shouldReinitPlayerOfInteract =
			this.props.placementType.toUpperCase() === 'SCENARIOS' &&
			this.props.reinitPlayer &&
			!prevProps.reinitPlayer;
		const shouldReinitPlayer =
			this.props.placementType.toUpperCase() !== 'SCENARIOS' &&
			this.props.refreshMediasIds.find((r) => r === this.props.mediaDetails?.id) &&
			((this.props.mediaDetails?.restrictions ?? []).length > 0 ||
				(prevProps.mediaDetails?.restrictions ?? []).length > 0);

		if ((shouldReinitPlayer || shouldReinitPlayerOfInteract) && !this.props.embedOnly) {
			window.QplayerLoader.killInteractivePlayer?.();
			const playerPreview = document.querySelector('#player-preview');
			playerPreview.innerHTML = '';
			this.initPlayer();
		}

		if (this.props.hide !== prevProps.hide && !this.props.embedOnly) {
			if (!this.props.hide) {
				this.initPlayer();
			} else {
				window.QplayerLoader.killInteractivePlayer?.();
			}
		}

		if (JSON.stringify(this.props.apps) !== JSON.stringify(prevProps.apps)) {
			this.loadPortalsData();
		}
	}

	componentWillUnmount() {
		!this.props.embedOnly && window.QplayerLoader.killInteractivePlayer?.();
	}

	initPlayer = () => {
		if (this.props.embedOnly) {
			return;
		}

		const { selectedPlayerConfig } = this.state;
		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;

		if (
			!isUsingTheoPlayer &&
			window.QplayerLoader.initiateInteractivePlayer &&
			typeof window.QplayerLoader.initiateInteractivePlayer === 'function'
		) {
			window.QplayerLoader.initiateInteractivePlayer();
		}
	};

	cleanTheoPlayer = () => {
		const theoPlayerInstant = document.querySelector('.LivePlayerWrapper > iframe');
		if (theoPlayerInstant) {
			theoPlayerInstant.remove();
		}
	};

	loadAccountPlayerConfiguration = () => {
		const { defaultAccountId, t, showMessage } = this.props;
		this.props.loadPlayerConfiguration(defaultAccountId).then((data) => {
			if (!data) {
				showMessage(t('SETTINGS_PRESET_CONFIG_LOAD_DATA_FAIL'), messageTypes.error);
				return;
			}

			let selectedPlayerConfig = data.find((config) => config.recommended);
			selectedPlayerConfig = selectedPlayerConfig ?? data[0];

			const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;

			const desktopLayout =
				selectedPlayerConfig.layouts.find((l) => l.type === 'desktop') ?? selectedPlayerConfig.layouts[0];

			const isStoryPreset = selectedPlayerConfig?.id?.toLowerCase().includes(publicConfigIds.Story.toLowerCase());
			const controls = isStoryPreset ? desktopLayout?.controls ?? {} : desktopLayout?.topControls ?? {};

			const muteAtStart = !isUsingTheoPlayer
				? !!desktopLayout?.playbackOptions?.muteAtStart
				: !!desktopLayout?.playbackOptions?.muted;
			const replay = !!desktopLayout?.playbackOptions?.replay;
			const autostart = !!desktopLayout?.playbackOptions?.autostart;
			const showSocialSharing = !!controls?.showSocialSharing;
			const showDownloadButton = !isUsingTheoPlayer
				? !!controls?.showDownloadButton
				: !!desktopLayout?.controls?.download;
			const softFullscreen = !!desktopLayout?.playbackOptions?.softFullscreen;
			const showOpenInNewWindow = !!controls?.showOpenInNewWindow;
			const playerSize = !isUsingTheoPlayer ? 'responsive' : 'fixedSize';
			const language = desktopLayout?.accessibilitySettings?.language;

			this.originPlayerConfig = {
				muteAtStart: muteAtStart,
				replay: replay,
				autostart: autostart,
				showSocialSharing: showSocialSharing,
				showDownloadButton: showDownloadButton,
				softFullscreen: softFullscreen,
				showOpenInNewWindow: showOpenInNewWindow,
				language: language,
			};

			this.props.onPlayerConfigChange?.(selectedPlayerConfig);
			this.setState({
				playerConfigs: [...data],
				selectedPlayerConfig,
				replay,
				muteAtStart,
				autostart,
				showSocialSharing,
				showDownloadButton,
				showOpenInNewWindow,
				playerSize,
				softFullscreen,
				language,
			});
		});
	};

	loadDefaultPlayerConfigs = () => {
		const { defaultAccountId, getAccountSettings } = this.props;
		getAccountSettings(defaultAccountId).then((settings) => {
			if (!settings || settings.length === 0) {
				return;
			}

			let defaultPlayerConfigs = [];
			if (
				settings.hasOwnProperty('qbrickPlayer') &&
				settings['qbrickPlayer'] &&
				settings['qbrickPlayer'].length > 0
			) {
				defaultPlayerConfigs = settings['qbrickPlayer'].find((v) => v.version === '2')?.presets?.defaults;
			}
			this.setState({ defaultPlayerConfigs: defaultPlayerConfigs });
		});
	};

	loadPortalsData = async () => {
		if (!checkPermissionGrantedFor(this.props.userPermissions, 'portals')) {
			return;
		}

		const result = await fetchAccountPortalThemesService({ accountId: this.props.defaultAccountId });
		if (!result) {
			return;
		}

		this.setState({ portalLayouts: result });
	};

	togglePlayerSettingOptions = (e) => {
		e.preventDefault();
		this.setState((prevState) => ({ showPlayerSettingOptions: !prevState.showPlayerSettingOptions }));
	};

	handlePlayerConfigsSelection = (event) => {
		const id = event.target.value;

		if (!id) {
			return;
		}

		const selectedPlayerConfig = this.state.playerConfigs.find((setting) => setting.id === id);

		this.setState((prevState) => {
			if (!prevState.selectedPlayerConfig || prevState.selectedPlayerConfig.id !== id) {
				const isUsingTheoPlayer = selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;

				const desktopLayout =
					selectedPlayerConfig.layouts?.find((l) => l.type === 'desktop') ??
					selectedPlayerConfig.layouts?.[0];

				const isStoryPreset = selectedPlayerConfig?.id
					?.toLowerCase()
					.includes(publicConfigIds.Story.toLowerCase());
				const controls = isStoryPreset ? desktopLayout?.controls ?? {} : desktopLayout?.topControls ?? {};

				const muteAtStart = !isUsingTheoPlayer
					? !!desktopLayout?.playbackOptions?.muteAtStart
					: !!desktopLayout?.playbackOptions?.muted;
				const replay = !!desktopLayout?.playbackOptions?.replay;
				const autostart = !!desktopLayout?.playbackOptions?.autostart;
				const showSocialSharing = !!controls?.showSocialSharing;
				const showDownloadButton = !isUsingTheoPlayer
					? !!controls?.showDownloadButton
					: !!desktopLayout?.controls?.download;
				const softFullscreen = !!desktopLayout?.playbackOptions?.softFullscreen;
				const showOpenInNewWindow = !!controls?.showOpenInNewWindow;
				const playerSize = !isUsingTheoPlayer ? 'responsive' : 'fixedSize';
				const language = desktopLayout?.accessibilitySettings?.language;

				this.originPlayerConfig = {
					muteAtStart: muteAtStart,
					replay: replay,
					autostart: autostart,
					showSocialSharing: showSocialSharing,
					showDownloadButton: showDownloadButton,
					softFullscreen: softFullscreen,
					showOpenInNewWindow: showOpenInNewWindow,
					language: language,
				};

				this.props.onPlayerConfigChange?.(selectedPlayerConfig);

				return {
					selectedPlayerConfig: selectedPlayerConfig,
					replay,
					muteAtStart,
					autostart,
					showSocialSharing,
					showDownloadButton,
					showOpenInNewWindow,
					playerSize,
					softFullscreen,
					language,
				};
			}
			return null;
		});
	};

	handlePortalSelectedSection = (event) => {
		const id = event.target.value;

		if (!id) {
			return;
		}

		this.setState({ selectedPortalLayoutId: id });
	};

	renderVideoActions = () => {
		const { selectedPlayerConfig } = this.state;
		const { scenario, t, placementType, setMediaForTrimming, mediaDetails } = this.props;
		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;
		const previewLink = !isUsingTheoPlayer && this.getPreviewLink();
		const downloadLink = this.getDownloadLink();
		const isEnableEditTool = mediaDetails?.duration;

		return (
			<div className="player-preview__video-actions">
				{placementType === 'medias' && isEnableEditTool && (
					<button
						style={{
							fill: 'red',
						}}
						className="player-preview__btn"
						title={t('MODAL_QUICK_EDIT_VIDEO_TITLE')}
						onClick={() => {
							setMediaForTrimming(mediaDetails);
							this.setState({
								isQuickEditShown: true,
							});
						}}
					>
						<ColorHub
							component={<ContentCut width={'18px'} height={'18px'} />}
							htmlColor="rgb(68, 74, 88)"
						/>
					</button>
				)}
				{!scenario && (
					<a
						target="_blank"
						href={downloadLink}
						download
						className="player-preview__btn"
						title={t('COMMON_DOWNLOAD')}
					>
						<img src={download_new} />
					</a>
				)}
				{!isUsingTheoPlayer && (
					<a target="_blank" href={previewLink} className="player-preview__btn" title={t('COMMON_PREVIEW')}>
						<img src={eye_black} />
					</a>
				)}
			</div>
		);
	};

	getDownloadLink = () => {
		const { videos } = this.state;
		return videos.length > 0 ? videos[0].link + '?download=true' : '#';
	};

	getSortedData = (list, property) => {
		let sortedArray = list.sort((a, b) => (a[property] <= b[property] ? 1 : -1));
		return sortedArray;
	};

	getVideoDownloadData = () => {
		const { mediaDetails } = this.props;
		let videos = [];
		mediaDetails &&
			mediaDetails.asset &&
			mediaDetails.asset.resources &&
			mediaDetails.asset.resources.map((resource) => {
				if (resource && resource.renditions) {
					resource.renditions.map((rendition) => {
						const link = rendition.links ? rendition.links[0].href : '';
						const arr = link ? link.split('/') : rendition.path ? rendition.path.split('/') : [];
						const lastName = arr.length > 0 ? arr[arr.length - 1] : '';
						const defaultName = '...' + (link ? link.slice(-17) : '');
						const name = lastName || defaultName;
						const genericObj = {
							resourceId: resource.id,
							renditionId: rendition.id,
							name: name,
							link: link,
						};
						switch (rendition.type) {
							case renditionTypes.VIDEO: {
								let tempVideoObj = {};
								if (rendition.videos && rendition.videos.length > 0) {
									tempVideoObj = { ...rendition.videos[0] };
								}
								const videoObj = {
									...genericObj,
									...rendition,
									...tempVideoObj,
								};
								videos.push(videoObj);
								break;
							}

							default:
								break;
						}
					});
				}
			});
		videos = this.getSortedData(videos, 'bitrate');
		this.setState({ videos: videos });
	};

	renderPlayerSettingSection = () => {
		const {
			playerConfigs,
			showPlayerSettingOptions,
			selectedPlayerConfig,
			autostart,
			muteAtStart,
			replay,
			fixedSize,
			playerSize,
			showSocialSharing,
			showDownloadButton,
			showOpenInNewWindow,
			defaultPlayerConfigs,
			softFullscreen,
			uniqueFrame,
			language,
			eventLink,
			overrideDefaultAspectRatio,
			overrideDefaultAspectRatioValue,
		} = this.state;
		const { t, userPermissions } = this.props;
		const configs = [...(playerConfigs ?? [])].filter((c) => c.id !== 'Shopping');
		if (!configs || configs.length === 0) {
			return null;
		}

		const defaultConfigs = configs.filter((s) => (defaultPlayerConfigs ?? []).includes(s.id));
		const presetConfigs = [...configs.filter((s) => !(defaultPlayerConfigs ?? []).includes(s.id))];
		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;
		const isUsingBonnierNews = selectedPlayerConfig && selectedPlayerConfig.id === BONNIER_NEW_PRESET_ID;
		const isStoryPreset = selectedPlayerConfig && selectedPlayerConfig.id.includes('Story');

		return (
			<div className="player-preview__player-setting-section">
				<FormControl fullWidth className="saved-preset-select__control">
					<div className="saved-preset-select__control-header">
						<label id={'player-config-select-label'} htmlFor={'player-config-select'}>
							{t('COMMON_PLAYER')}
						</label>
						{FeaturesService.IsEnabled(userPermissions, 'QbrickPlayerEditor') && (
							<a href="#/settings/players" target="_blank" className="player-preview__link">
								<Settings />
								<span>{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_PRESET_SETTINGS')}</span>
							</a>
						)}
					</div>

					{configs && configs.length > 0 && (
						<Select
							labelId={'player-config-select-label'}
							id={'player-config-select'}
							value={selectedPlayerConfig ? selectedPlayerConfig.id : 0}
							disableUnderline
							style={{ marginTop: '6px' }}
							onChange={this.handlePlayerConfigsSelection}
						>
							<MenuItem key={0} value={0} className="player-config-select-option" disabled>
								{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_CHOOSE_PLAYER')}
							</MenuItem>
							<div className="player-config-select__subheader">
								{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_DEFAULT_PRESETS')}
							</div>
							{defaultConfigs.map((config, index) => (
								<MenuItem key={index} value={config.id} className="player-config-select-option">
									<div className="player-config-select-option__default-label">
										<div className="player-config-select-option__primary-text">
											{defaultSettingTypes[config.id.toLowerCase()]?.name}
										</div>
										<div className="player-config-select-option__secondary-text">
											{t(defaultSettingTypes[config.id.toLowerCase()]?.note)}
										</div>
									</div>
								</MenuItem>
							))}
							{presetConfigs && presetConfigs.length > 0 && <Divider />}
							{presetConfigs && presetConfigs.length > 0 && (
								<div className="player-config-select__subheader">
									{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_SAVED_PRESETS')}
								</div>
							)}
							{presetConfigs &&
								presetConfigs.length > 0 &&
								presetConfigs.map((config, index) => (
									<MenuItem key={index} value={config.id} className="player-config-select-option">
										{config.name}
									</MenuItem>
								))}
						</Select>
					)}
				</FormControl>

				<div className="player-preview__player-setting-options">
					{!isUsingBonnierNews && (
						<a href="/#" onClick={this.togglePlayerSettingOptions} className="player-preview__link">
							{showPlayerSettingOptions ? (
								<>
									<Remove />{' '}
									<span>
										{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_HIDE_OPTIONS')}
									</span>
								</>
							) : (
								<>
									<Add />{' '}
									<span>
										{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_SHOW_OPTIONS')}
									</span>
								</>
							)}
						</a>
					)}
					{showPlayerSettingOptions && !isUsingBonnierNews && (
						<>
							{!isUsingTheoPlayer && (
								<FormControl fullWidth>
									<FormControlLabel
										control={
											<Checkbox style={{ color: '#126CFC' }} name="4" checked={softFullscreen} />
										}
										label={t(advancedSettingLabels['softFullscreen'])}
										onChange={this.handleSoftFullscreenChange}
									/>
								</FormControl>
							)}
							<FormControl fullWidth>
								<FormControlLabel
									control={<Checkbox style={{ color: '#126CFC' }} name="4" checked={autostart} />}
									label={t(advancedSettingLabels['autostart'])}
									onChange={this.handleAutoStartChange}
								/>
							</FormControl>
							<FormControl fullWidth>
								<FormControlLabel
									control={<Checkbox style={{ color: '#126CFC' }} name="4" checked={muteAtStart} />}
									label={t(advancedSettingLabels['muteAtStart'])}
									onChange={this.handleMuteAtStartChange}
								/>
							</FormControl>
							<FormControl fullWidth>
								<FormControlLabel
									control={<Checkbox style={{ color: '#126CFC' }} name="4" checked={replay} />}
									label={t(advancedSettingLabels['replay'])}
									onChange={this.handleReplayChange}
								/>
							</FormControl>
							{!isUsingTheoPlayer && (
								<FormControl fullWidth>
									<FormControlLabel
										control={
											<Checkbox
												style={{ color: '#126CFC' }}
												name="4"
												checked={showSocialSharing}
											/>
										}
										label={t(advancedSettingLabels['showSocialSharing'])}
										onChange={this.handleShowSocialSharingChange}
									/>
								</FormControl>
							)}

							<FormControl fullWidth>
								<FormControlLabel
									control={
										<Checkbox style={{ color: '#126CFC' }} name="4" checked={showDownloadButton} />
									}
									label={t(advancedSettingLabels['showDownloadButton'])}
									onChange={this.handleShowDownloadButtonChange}
								/>
							</FormControl>

							{!isUsingTheoPlayer && (
								<FormControl fullWidth>
									<FormControlLabel
										control={
											<Checkbox
												style={{ color: '#126CFC' }}
												name="4"
												checked={showOpenInNewWindow}
											/>
										}
										label={t(advancedSettingLabels['showOpenInNewWindow'])}
										onChange={this.handleShowOpenInNewWindowButtonChange}
									/>
								</FormControl>
							)}

							{!isUsingTheoPlayer && (
								<FormControl fullWidth>
									<FormControlLabel
										control={
											<Checkbox style={{ color: '#126CFC' }} name="4" checked={uniqueFrame} />
										}
										label={t(advancedSettingLabels['uniqueFrame'])}
										onChange={this.handleShowUniqueFrameChange}
									/>
								</FormControl>
							)}

							{!isUsingTheoPlayer && (
								<FormControl fullWidth>
									<FormControlLabel
										className="player-preview__select"
										fullWidth
										control={
											<Select value={language} variant="outlined">
												{a11yLanguages.map((lang, index) => (
													<MenuItem
														key={index}
														value={lang.languageCode}
														className="a11y-lang-select-option"
													>
														{t(a11yLanguagesTranslateLabels[lang.languageCode].name)}
													</MenuItem>
												))}
											</Select>
										}
										label={t('COMMON_LANGUAGE')}
										labelPlacement="top"
										onChange={this.handleLanguageChange}
									/>
								</FormControl>
							)}

							<div className="player-preview__size-options">
								<FormControl fullWidth>
									<RadioGroup
										defaultValue="responsive"
										value={playerSize}
										onChange={this.handlePlayerSizeChange}
									>
										{!isUsingTheoPlayer && (
											<FormControlLabel
												control={<Radio style={{ color: '#126CFC' }} />}
												label={t('COMMON_RESPONSIVE')}
												value="responsive"
											/>
										)}
										<div className="player-preview__fixed-size">
											{!isUsingTheoPlayer ? (
												<FormControlLabel
													control={<Radio style={{ color: '#126CFC' }} />}
													label={t(
														'MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_FIXED_SIZE'
													)}
													value="fixedSize"
												/>
											) : (
												<span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
													{`${t(
														'MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_FIXED_SIZE'
													)}:`}
												</span>
											)}

											<div className="player-preview__fixed-size-inputs">
												<input
													type="number"
													value={fixedSize.width}
													disabled={playerSize !== 'fixedSize'}
													onChange={this.handleFixedSizeWidthChange}
												/>
												<span>x</span>
												<input
													type="number"
													value={fixedSize.height}
													disabled={playerSize !== 'fixedSize'}
													onChange={this.handleFixedSizeHeightChange}
												/>
											</div>
										</div>
									</RadioGroup>
								</FormControl>
							</div>

							<FormControl fullWidth>
								<div className="player-preview__fixed-size" style={{ marginTop: 16 }}>
									<FormControlLabel
										control={
											<Checkbox
												style={{ color: '#126CFC' }}
												name="4"
												checked={overrideDefaultAspectRatio}
												disabled={isStoryPreset}
											/>
										}
										label={t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_OVERRIDE_DEFAULT_ASPECT_RATIO')}
										onChange={this.handleOverrideDefaultAspectRatioChange}
									/>
									<div className="player-preview__fixed-size-inputs">
										<Select
											value={overrideDefaultAspectRatioValue}
											variant="outlined"
											style={{ height: 36, fontSize: 12, background: '#fff' }}
											disabled={!overrideDefaultAspectRatio}
											onChange={(e) =>
												this.setState({ overrideDefaultAspectRatioValue: e.target.value })
											}
										>
											<MenuItem key={'16/9'} value={'16/9'} className="a11y-lang-select-option">
												16/9
											</MenuItem>
											<MenuItem key={'9/16'} value={'9/16'} className="a11y-lang-select-option">
												9/16
											</MenuItem>
										</Select>
									</div>
								</div>
							</FormControl>

							{!isUsingTheoPlayer && (
								<FormControl fullWidth>
									<FormControlLabel
										className="player-preview__select"
										fullWidth
										control={
											<OutlinedInput
												value={eventLink}
												placeholder={t(
													'MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_EVENT_LINK_PLACEHOLDER'
												)}
											/>
										}
										label={t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_EVENT_LINK')}
										labelPlacement="top"
										onChange={this.handleEventLinkChange}
									/>
								</FormControl>
							)}
						</>
					)}
				</div>
			</div>
		);
	};

	handleSoftFullscreenChange = (e, checked) => {
		this.setState({ softFullscreen: checked });
	};

	handleAutoStartChange = (e, checked) => {
		this.setState({ autostart: checked });
	};

	handleReplayChange = (e, checked) => {
		this.setState({ replay: checked });
	};

	handleMuteAtStartChange = (e, checked) => {
		this.setState({ muteAtStart: checked });
	};

	handleShowSocialSharingChange = (e, checked) => {
		this.setState({ showSocialSharing: checked });
	};

	handleShowDownloadButtonChange = (e, checked) => {
		this.setState({ showDownloadButton: checked });
	};

	handleShowOpenInNewWindowButtonChange = (e, checked) => {
		this.setState({ showOpenInNewWindow: checked });
	};

	handleShowUniqueFrameChange = (e, checked) => {
		this.setState({ uniqueFrame: checked });
	};

	handleOverrideDefaultAspectRatioChange = (e, checked) => {
		this.setState({ overrideDefaultAspectRatio: checked });
	};

	handleLanguageChange = (e) => {
		this.setState({ language: e.target.value });
	};

	handlePlayerSizeChange = (e, value) => {
		this.setState({ playerSize: value });
	};

	handleFixedSizeWidthChange = (e) => {
		this.setState((prevState) => ({ fixedSize: { width: e.target.value, height: prevState.fixedSize.height } }));
	};

	handleFixedSizeHeightChange = (e) => {
		this.setState((prevState) => ({ fixedSize: { height: e.target.value, width: prevState.fixedSize.width } }));
	};

	// Overrides. Left empty the preset decides, so none appears in the snippet until it is filled in.
	REELS_FIELDS = [
		{ key: 'reelsUrlPattern', label: 'REELS_URL', placeholder: '/shorts/{playlistId}/{mediaId}' },
		{ key: 'reelsGalleryUrl', label: 'REELS_GALLERY_URL', placeholder: '/shorts' },
		{ key: 'reelsAdTag', label: 'REELS_AD_TAG', placeholder: 'https://…/vast.xml' },
		{ key: 'reelsAdInterval', label: 'REELS_AD_INTERVAL', placeholder: '3', type: 'number' },
		{ key: 'reelsAdSkipAfter', label: 'REELS_AD_SKIP_AFTER', placeholder: '5', type: 'number' },
	];

	renderReelsFields = () => {
		const { t } = this.props;
		const key = (label, part) => `MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_${label}_${part}`;

		return this.REELS_FIELDS.map(({ key: stateKey, label, placeholder, type }) => (
			<div className="player-preview__reels-field" key={stateKey}>
				<label htmlFor={stateKey}>{t(key(label, 'LABEL'))}</label>
				<div className="player-preview__embed-code-container player-preview__embed-code-preview-link">
					<input
						id={stateKey}
						type={type ?? 'text'}
						min={type === 'number' ? '0' : undefined}
						className="player-preview__embed-code"
						placeholder={placeholder}
						value={this.state[stateKey]}
						onChange={(event) => this.setState({ [stateKey]: event.target.value })}
					/>
				</div>
				<p className="player-preview__embed-hint">{t(key(label, 'HINT'))}</p>
			</div>
		));
	};

	/** A Story preset playing a PLAYLIST - the rule the player itself gates on. */
	isReelsPlacement = () => {
		const { placementType } = this.props;
		const { selectedPlayerConfig } = this.state;
		return (
			!!selectedPlayerConfig?.id?.toLowerCase().includes(publicConfigIds.Story.toLowerCase()) &&
			String(placementType).toLowerCase() === 'playlists'
		);
	};

	/**
	 * Its own section, not another block under the embed codes: six of the eight settings above it
	 * never reach a reels feed.
	 */
	renderReelsSection = () => {
		const { t } = this.props;

		if (!this.isReelsPlacement()) {
			return null;
		}

		return (
			<div className="player-preview__embed-section">
				<label>{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_REELS_EMBED')}</label>
				<div className="player-preview__embed-code-container">
					<textarea
						className="player-preview__embed-code"
						placeholder="Reels embed"
						readOnly
						value={this.getReelsEmbedCode()}
					/>
					<CopyToClipboard text={this.getReelsEmbedCode()} onCopy={this.copyReelsEmbedCode}>
						<button title={t('COMMON_CLICK_TO_COPY')} className="player-preview__btn">
							<img src={copy_text} />
						</button>
					</CopyToClipboard>
				</div>
				<p className="player-preview__embed-hint">
					{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_REELS_GALLERY_HINT')}
				</p>

				<button
					type="button"
					className="player-preview__reels-toggle"
					aria-expanded={this.state.reelsAdvancedOpen}
					onClick={() => this.setState((prev) => ({ reelsAdvancedOpen: !prev.reelsAdvancedOpen }))}
				>
					{this.state.reelsAdvancedOpen ? '\u25be' : '\u25b8'}{' '}
					{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_REELS_ADVANCED')}
				</button>
				{this.state.reelsAdvancedOpen && this.renderReelsFields()}
			</div>
		);
	};

	renderEmbedSection = () => {
		const { t, mediaDetails } = this.props;
		const { selectedPlayerConfig } = this.state;
		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;
		const isUsingBonnierNews = selectedPlayerConfig && selectedPlayerConfig.id === BONNIER_NEW_PRESET_ID;
		//Will update Story to constant when preset is added
		const isUsingStoryPlayer =
			selectedPlayerConfig && selectedPlayerConfig.id === 'Story' && mediaDetails.type !== 'playlists';

		const divEmbedCode =
			this.state.selectedDivEmbedVersion === '1.0' ? this.getDivEmbedCode() : this.getDivEmbedCodeV1_1();
		const previewLink = !isUsingTheoPlayer && this.getPreviewLink();
		const iFrameEmbedCode = !isUsingTheoPlayer && this.getIframeEmbedCode();
		const qplayerWidgetDivEmbedCode =
			this.state.selectedDivEmbedVersion === '1.0'
				? this.getQplayerWidgetDivEmbedCode()
				: this.getQplayerWidgetDivEmbedCodeV1_1();

		return (
			<div className="player-preview__embed-section">
				<label>{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_DIV_EMBED')}</label>
				<div className="player-preview__embed-version-labels">
					<div
						className={joinClassNames(
							'player-preview__embed-version-tab',
							this.state.selectedDivEmbedVersion === '1.1' &&
								'player-preview__embed-version-tab--selected'
						)}
						onClick={() => this.setState({ selectedDivEmbedVersion: '1.1' })}
					>
						Ver 1.1 <span className="player-preview__embed-version-new">New</span>
					</div>
					<div
						className={joinClassNames(
							'player-preview__embed-version-tab',
							this.state.selectedDivEmbedVersion === '1.0' &&
								'player-preview__embed-version-tab--selected'
						)}
						onClick={() => this.setState({ selectedDivEmbedVersion: '1.0' })}
					>
						Ver 1.0
					</div>
				</div>
				<div className="player-preview__embed-code-container">
					<textarea
						className="player-preview__embed-code"
						placeholder="Div embed"
						readOnly
						value={divEmbedCode}
					/>
					<CopyToClipboard text={divEmbedCode} onCopy={this.copyDivEmbed}>
						<button title={t('COMMON_CLICK_TO_COPY')} className="player-preview__btn">
							<img src={copy_text} />
						</button>
					</CopyToClipboard>
				</div>

				{!isUsingTheoPlayer && !isUsingBonnierNews && (
					<>
						<label>{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_IFRAME_EMBED')}</label>
						<div className="player-preview__embed-code-container">
							<textarea
								className="player-preview__embed-code"
								placeholder="iFrame embed"
								readOnly
								value={iFrameEmbedCode}
							/>
							<CopyToClipboard text={iFrameEmbedCode} onCopy={this.copyIFrameEmbedCode}>
								<button title={t('COMMON_CLICK_TO_COPY')} className="player-preview__btn">
									<img src={copy_text} />
								</button>
							</CopyToClipboard>
						</div>
						{isUsingStoryPlayer && (
							<>
								<label>
									{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_QPLAYER_WIDGET_EMBED')}
								</label>
								<div className="player-preview__embed-version-labels">
									<div
										className={joinClassNames(
											'player-preview__embed-version-tab',
											this.state.selectedDivEmbedVersion === '1.0' &&
												'player-preview__embed-version-tab--selected'
										)}
										onClick={() => this.setState({ selectedDivEmbedVersion: '1.0' })}
									>
										Ver 1.0
									</div>
									<div
										className={joinClassNames(
											'player-preview__embed-version-tab',
											this.state.selectedDivEmbedVersion === '1.1' &&
												'player-preview__embed-version-tab--selected'
										)}
										onClick={() => this.setState({ selectedDivEmbedVersion: '1.1' })}
									>
										Ver 1.1 <span className="player-preview__embed-version-new">New</span>
									</div>
								</div>
								<div className="player-preview__embed-code-container">
									<textarea
										className="player-preview__embed-code"
										placeholder="Widget embed"
										readOnly
										value={qplayerWidgetDivEmbedCode}
									/>
									<CopyToClipboard
										text={qplayerWidgetDivEmbedCode}
										onCopy={this.copyQplayerWidgetEmbedCode}
									>
										<button title={t('COMMON_CLICK_TO_COPY')} className="player-preview__btn">
											<img src={copy_text} />
										</button>
									</CopyToClipboard>
								</div>
							</>
						)}
						<label>{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_PREVIEW_LINK')}</label>
						<div className="player-preview__embed-code-container player-preview__embed-code-preview-link">
							<input
								className="player-preview__embed-code"
								placeholder={t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_PREVIEW_LINK')}
								readOnly
								value={previewLink}
							/>

							<CopyToClipboard text={previewLink} onCopy={this.copyPreviewLink}>
								<button title={t('COMMON_CLICK_TO_COPY')} className="player-preview__btn">
									<img src={copy_text} />
								</button>
							</CopyToClipboard>
						</div>
					</>
				)}
			</div>
		);
	};

	renderPortalSharingSection = (mediaType) => {
		const { t, mediaDetails, defaultAccountId } = this.props;
		const { portalLayouts, selectedPortalLayoutId } = this.state;

		if (!portalLayouts || !portalLayouts.length) {
			return;
		}

		const portalUrl = `${portalsUrl}${INDIVIDUAL_SHARE_PORTAL_ID}?pId=${
			selectedPortalLayoutId || portalLayouts[0].themeId
		}&aid=${defaultAccountId}&${mediaType}Id=${mediaDetails.id}`;

		return (
			<div className="player-preview__embed-section">
				<FormControl fullWidth className="saved-preset-select__control">
					<label>{t('COMMON_PORTAL_PRESET')}</label>
					{portalLayouts && portalLayouts.length > 0 && (
						<Select
							value={selectedPortalLayoutId || portalLayouts[0].themeId}
							disableUnderline
							style={{ marginTop: '6px' }}
							onChange={this.handlePortalSelectedSection}
						>
							<MenuItem key={0} value={0} className="player-config-select-option" disabled>
								{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_CHOOSE_PORTAL')}
							</MenuItem>
							{portalLayouts &&
								portalLayouts.length > 0 &&
								portalLayouts.map(({ themeId, name }) => (
									<MenuItem key={themeId} value={themeId} className="player-config-select-option">
										{name ?? 'Untitle'}
									</MenuItem>
								))}
						</Select>
					)}
				</FormControl>
				<label>{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_PORTAL_LINK')}</label>
				<div className="player-preview__embed-code-container player-preview__embed-code-preview-link">
					<input
						className="player-preview__embed-code"
						placeholder={t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_PORTAL_LINK')}
						readOnly
						value={portalUrl}
					/>

					<CopyToClipboard text={portalUrl} onCopy={this.copyPortalLink}>
						<button title={t('COMMON_CLICK_TO_COPY')} className="player-preview__btn">
							<img src={copy_text} />
						</button>
					</CopyToClipboard>
					<a
						target="_blank"
						href={portalUrl}
						className="player-preview__btn"
						style={{ marginLeft: 5, marginRight: 0 }}
						title={t('COMMON_PREVIEW')}
					>
						<img src={eye_black} />
					</a>
				</div>
			</div>
		);
	};

	copyPreviewLink = (_) => {
		this.props.showNotification(
			this.props.t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_LABEL_PREVIEW_LINK_COPIED')
		);
	};

	copyDivEmbed = (_) => {
		this.props.showNotification(
			this.props.t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_LABEL_EMBED_CODE_COPIED')
		);
	};

	copyIFrameEmbedCode = (_) => {
		this.props.showNotification(
			this.props.t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_LABEL_IFRAME_CODE_COPIED')
		);
	};

	copyQplayerWidgetEmbedCode = (_) => {
		this.props.showNotification(
			this.props.t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_LABEL_QPLAYER_WIDGET_CODE_COPIED')
		);
	};

	copyReelsEmbedCode = (_) => {
		this.props.showNotification(
			this.props.t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_LABEL_EMBED_CODE_COPIED')
		);
	};

	copyPortalLink = (_) => {
		this.props.showNotification(
			this.props.t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_PORTALS_SHARING_LINK_COPIED')
		);
	};

	getIframeEmbedCode = (_) => {
		const {
			replay,
			autostart,
			selectedPlayerConfig,
			muteAtStart,
			fixedSize,
			playerSize,
			showDownloadButton,
			showSocialSharing,
			showOpenInNewWindow,
			uniqueFrame,
			language,
		} = this.state;
		const { defaultAccountId, placementType, mediaDetails } = this.props;
		if (!selectedPlayerConfig) {
			return '';
		}

		const title = mediaDetails?.metadata?.title;
		const themeOptionsDefault = selectedPlayerConfig.id;
		const mediaIdOrPlaylistId =
			placementType && placementType.toUpperCase() === 'MEDIAS'
				? 'mediaId'
				: placementType.toUpperCase() === 'SCENARIOS'
				? 'scenarioId'
				: 'playlistId';
		const width = fixedSize && playerSize === 'fixedSize' ? fixedSize.width : '100%';
		const height = fixedSize && playerSize === 'fixedSize' ? fixedSize.height : '100%';

		const muteAtStartAttr =
			this.originPlayerConfig && muteAtStart !== this.originPlayerConfig.muteAtStart
				? `&mute=${muteAtStart}`
				: '';
		const autostartAttr =
			this.originPlayerConfig && autostart !== this.originPlayerConfig.autostart ? `&autoplay=${autostart}` : '';
		const showSocialSharingAttr =
			this.originPlayerConfig && showSocialSharing !== this.originPlayerConfig.showSocialSharing
				? `&sharing=${showSocialSharing}`
				: '';
		const replayAttr =
			this.originPlayerConfig && replay !== this.originPlayerConfig.replay ? `&repeat=${replay}` : '';
		const showDownloadButtonAttr =
			this.originPlayerConfig && showDownloadButton !== this.originPlayerConfig.showDownloadButton
				? `&downloadMedia=${showDownloadButton}`
				: '';
		const showOpenInNewWindowAttr =
			this.originPlayerConfig && showOpenInNewWindow !== this.originPlayerConfig.showOpenInNewWindow
				? `&openInNewWindow=${showOpenInNewWindow}`
				: '';
		const uniqueFrameAttr = uniqueFrame ? `&uniqueFrame=${uniqueFrame}` : '';
		const languageAttr =
			language && this.originPlayerConfig && language !== this.originPlayerConfig.language
				? `&language=${language}`
				: '';

		if (playerSize === 'responsive') {
			const isStoryPreset = selectedPlayerConfig?.id?.toLowerCase().includes(publicConfigIds.Story.toLowerCase());
			// video ratio 16:9, set padding-bottom 56.25%; video ratio 1:1, set padding-bottom 100%
			const paddingRatio = isStoryPreset ? '177.78%' : '56.25%';
			return (
				`<div style="position:relative;padding-bottom:${paddingRatio};">` +
				`<iframe title="${title}" src="${qplayerDomain}?accountId=${defaultAccountId}&${mediaIdOrPlaylistId}=${mediaDetails.id}&configId=${themeOptionsDefault}${languageAttr}${autostartAttr}${showSocialSharingAttr}${showDownloadButtonAttr}${showOpenInNewWindowAttr}${replayAttr}${muteAtStartAttr}${uniqueFrameAttr}"` +
				` allowFullScreen="true" frameborder="0" border="0" height="${height}" width="${width}" style="position:absolute;top:0;left:0;"></iframe>` +
				`</div>`
			);
		}

		return `<iframe title="${title}" src="${qplayerDomain}?accountId=${defaultAccountId}&${mediaIdOrPlaylistId}=${mediaDetails.id}&configId=${themeOptionsDefault}${languageAttr}${autostartAttr}${showSocialSharingAttr}${showDownloadButtonAttr}${showOpenInNewWindowAttr}${replayAttr}${muteAtStartAttr}${uniqueFrameAttr}"" allowFullScreen="true" frameborder="0" border="0" height="${height}" width="${width}"></iframe>`;
	};

	getPreviewLink = (_) => {
		const {
			replay,
			autostart,
			selectedPlayerConfig,
			muteAtStart,
			showDownloadButton,
			showSocialSharing,
			showOpenInNewWindow,
			uniqueFrame,
			language,
			eventLink,
		} = this.state;
		const { mediaDetails, defaultAccountId, placementType } = this.props;
		if (!selectedPlayerConfig) {
			return '';
		}

		const mediaIdOrPlaylistId =
			placementType && placementType.toUpperCase() === 'MEDIAS'
				? 'mediaId'
				: placementType.toUpperCase() === 'SCENARIOS'
				? 'scenarioId'
				: 'playlistId';
		const themeOptionsDefault = selectedPlayerConfig.id;

		const muteAtStartAttr =
			this.originPlayerConfig && muteAtStart !== this.originPlayerConfig.muteAtStart
				? `&mute=${muteAtStart}`
				: '';
		const autostartAttr =
			this.originPlayerConfig && autostart !== this.originPlayerConfig.autostart ? `&autoplay=${autostart}` : '';
		const showSocialSharingAttr =
			this.originPlayerConfig && showSocialSharing !== this.originPlayerConfig.showSocialSharing
				? `&sharing=${showSocialSharing}`
				: '';
		const replayAttr =
			this.originPlayerConfig && replay !== this.originPlayerConfig.replay ? `&repeat=${replay}` : '';
		const showDownloadButtonAttr =
			this.originPlayerConfig && showDownloadButton !== this.originPlayerConfig.showDownloadButton
				? `&downloadMedia=${showDownloadButton}`
				: '';
		const showOpenInNewWindowAttr =
			this.originPlayerConfig && showOpenInNewWindow !== this.originPlayerConfig.showOpenInNewWindow
				? `&openInNewWindow=${showOpenInNewWindow}`
				: '';
		const uniqueFrameAttr = uniqueFrame ? `&uniqueFrame=${uniqueFrame}` : '';
		const languageAttr =
			language && this.originPlayerConfig && language !== this.originPlayerConfig.language
				? `&language=${language}`
				: '';
		const eventLinkAttr = eventLink && eventLink.trim() ? `&eventLink=${encodeURIComponent(eventLink.trim())}` : '';

		return `${qplayerDomain}?accountId=${defaultAccountId}&${mediaIdOrPlaylistId}=${mediaDetails.id}&configId=${themeOptionsDefault}${languageAttr}${autostartAttr}${showSocialSharingAttr}${showDownloadButtonAttr}${showOpenInNewWindowAttr}${replayAttr}${muteAtStartAttr}${uniqueFrameAttr}${eventLinkAttr}`;
	};

	getDivEmbedCodeV1_1 = (_) => {
		const {
			replay,
			autostart,
			selectedPlayerConfig,
			muteAtStart,
			showSocialSharing,
			showDownloadButton,
			showOpenInNewWindow,
			playerSize,
			fixedSize,
			softFullscreen,
			uniqueFrame,
			language,
			eventLink,
			overrideDefaultAspectRatio,
			overrideDefaultAspectRatioValue,
		} = this.state;
		const { mediaDetails, defaultAccountId, placementType } = this.props;
		if (!selectedPlayerConfig) {
			return '';
		}

		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;
		const isUsingBonnierNews = selectedPlayerConfig && selectedPlayerConfig.id === BONNIER_NEW_PRESET_ID;

		const title = mediaDetails?.metadata?.title;
		const muteAtStartAttr =
			this.originPlayerConfig && muteAtStart !== this.originPlayerConfig.muteAtStart
				? `data-qplayer-mute="${muteAtStart}" `
				: '';
		const autostartAttr =
			this.originPlayerConfig && autostart !== this.originPlayerConfig.autostart
				? `data-qplayer-autoplay="${autostart}" `
				: '';
		const showSocialSharingAttr =
			this.originPlayerConfig && showSocialSharing !== this.originPlayerConfig.showSocialSharing
				? `data-qplayer-sharing="${showSocialSharing}" `
				: '';
		const replayAttr =
			this.originPlayerConfig && replay !== this.originPlayerConfig.replay
				? `data-qplayer-repeat="${replay}" `
				: '';
		const showDownloadButtonAttr =
			this.originPlayerConfig && showDownloadButton !== this.originPlayerConfig.showDownloadButton
				? `data-qplayer-download="${showDownloadButton}" `
				: '';
		const showOpenInNewWindowAttr =
			this.originPlayerConfig && showOpenInNewWindow !== this.originPlayerConfig.showOpenInNewWindow
				? `data-qplayer-openInNewWindow="${showOpenInNewWindow}" `
				: '';
		const uniqueFrameAttr = uniqueFrame ? `data-qplayer-unique-frame="${uniqueFrame}"` : '';
		const mediaType =
			placementType && placementType.toUpperCase() === 'MEDIAS'
				? 'media'
				: placementType.toUpperCase() === 'SCENARIOS'
				? 'scenario'
				: 'playlist';
		const languageAttr =
			language && this.originPlayerConfig && language !== this.originPlayerConfig.language
				? `data-qplayer-language="${language}"`
				: '';
		const eventLinkAttr = eventLink && eventLink.trim() ? `data-qplayer-event-link="${eventLink.trim()}" ` : '';

		if (isUsingTheoPlayer) {
			return (
				`<div ${placementType !== 'playlist' ? 'bonnier-player-media-id' : 'bonnier-player-playlist-id'}="${
					mediaDetails.id
				}" ` +
				`account="${defaultAccountId}" ` +
				(autostart ? `autoplay ` : '') +
				`backdrop ` +
				(replay ? `replay ` : '') +
				(showDownloadButton ? `download ` : '') +
				(muteAtStart ? `muted ` : '') +
				`style="width:${fixedSize.width}px;height:${fixedSize.height}px"/>` +
				`<script type="text/javascript" src="${
					selectedPlayerConfig.layouts[0]?.playerStyling?.script ?? DEFAULT_THEO_PLAYER_EMBED
				}" async ></script>`
			);
		}

		if (isUsingBonnierNews) {
			return `<div class="bn-video-player" data-api-url="${readPublicApiEndpointV1}${defaultAccountId}/${mediaType}s/${mediaDetails.id}"></div>`;
		}

		const isStoryPreset = selectedPlayerConfig?.id?.toLowerCase().includes(publicConfigIds.Story.toLowerCase());
		// video ratio 16:9, set padding-bottom 56.25%; video ratio 1:1, set padding-bottom 100%
		let videoRatio = '16/9';

		if (isStoryPreset) {
			videoRatio = '9/16';
		} else if (overrideDefaultAspectRatio) {
			videoRatio = overrideDefaultAspectRatioValue;
		} else if (mediaDetails.aspectRatio) {
			videoRatio = mediaDetails.aspectRatio;
		}

		if (softFullscreen) {
			return playerSize === 'responsive'
				? `<qplayer-modal-embed title="${title}" ` +
						`data-qplayer-id="qplayer-${generateRandomId()}" ` +
						`data-qplayer-account-id="${defaultAccountId}" ` +
						`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
						`data-qplayer-preset-id="${selectedPlayerConfig.id}" ` +
						`${languageAttr}` +
						`${autostartAttr}` +
						`${showSocialSharingAttr}` +
						`${muteAtStartAttr}` +
						`${replayAttr}` +
						`${uniqueFrameAttr}` +
						`${showDownloadButtonAttr}` +
						`${showOpenInNewWindowAttr}` +
						`${eventLinkAttr}` +
						`data-qplayer-aspect-ratio="${videoRatio}"></qplayer-modal-embed>\n` +
						`<script src="${qplayerWebComponentLoaderUrl}"></script>`
				: `<qplayer-modal-embed style="width:${fixedSize.width}px;height:${fixedSize.height}px" ` +
						`title="${title}" ` +
						`data-qplayer-thumbnail-width="${fixedSize.width}" ` +
						`data-qplayer-thumbnail-height="${fixedSize.height}" ` +
						`data-qplayer-account-id="${defaultAccountId}" ` +
						`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
						`data-qplayer-preset-id="${selectedPlayerConfig.id}" ` +
						`${languageAttr}` +
						`${autostartAttr}` +
						`${showSocialSharingAttr}` +
						`${muteAtStartAttr}` +
						`${replayAttr}` +
						`${uniqueFrameAttr}` +
						`${showDownloadButtonAttr}` +
						`${showOpenInNewWindowAttr}` +
						`${eventLinkAttr}></qplayer-modal-embed>\n` +
						`<script src="${qplayerWebComponentLoaderUrl}"></script>`;
		}

		if (playerSize === 'responsive') {
			return (
				`<qplayer-embed title="${title}" ` +
				`data-qplayer-id="qplayer-${generateRandomId()}" ` +
				`data-qplayer-account-id="${defaultAccountId}" ` +
				`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
				`data-qplayer-preset-id="${selectedPlayerConfig.id}" ` +
				`${languageAttr}` +
				`${autostartAttr}` +
				`${showSocialSharingAttr}` +
				`${muteAtStartAttr}` +
				`${replayAttr}` +
				`${uniqueFrameAttr}` +
				`${showDownloadButtonAttr}` +
				`${showOpenInNewWindowAttr}` +
				`data-qplayer-aspect-ratio="${videoRatio}"></qplayer-embed>\n` +
				`<script src="${qplayerWebComponentLoaderUrl}"></script>`
			);
		}

		return (
			`<qplayer-embed style="width:${fixedSize.width}px;height:${fixedSize.height}px" ` +
			`title="${title}" ` +
			`data-qplayer-thumbnail-width="${fixedSize.width}" ` +
			`data-qplayer-thumbnail-height="${fixedSize.height}" ` +
			`data-qplayer-account-id="${defaultAccountId}" ` +
			`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
			`data-qplayer-preset-id="${selectedPlayerConfig.id}" ` +
			`${languageAttr}` +
			`${autostartAttr}` +
			`${showSocialSharingAttr}` +
			`${muteAtStartAttr}` +
			`${replayAttr}` +
			`${uniqueFrameAttr}` +
			`${showDownloadButtonAttr}></qplayer-embed>\n` +
			`<script src="${qplayerWebComponentLoaderUrl}"></script>`
		);
	};

	getDivEmbedCode = (_) => {
		const {
			replay,
			autostart,
			selectedPlayerConfig,
			muteAtStart,
			showSocialSharing,
			showDownloadButton,
			showOpenInNewWindow,
			playerSize,
			fixedSize,
			softFullscreen,
			uniqueFrame,
			language,
			eventLink,
		} = this.state;
		const { mediaDetails, defaultAccountId, placementType } = this.props;
		if (!selectedPlayerConfig) {
			return '';
		}

		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;
		const isUsingBonnierNews = selectedPlayerConfig && selectedPlayerConfig.id === BONNIER_NEW_PRESET_ID;

		const title = mediaDetails?.metadata?.title;
		const muteAtStartAttr =
			this.originPlayerConfig && muteAtStart !== this.originPlayerConfig.muteAtStart
				? `data-qplayer-mute="${muteAtStart}" `
				: '';
		const autostartAttr =
			this.originPlayerConfig && autostart !== this.originPlayerConfig.autostart
				? `data-qplayer-autoplay="${autostart}" `
				: '';
		const showSocialSharingAttr =
			this.originPlayerConfig && showSocialSharing !== this.originPlayerConfig.showSocialSharing
				? `data-qplayer-sharing="${showSocialSharing}" `
				: '';
		const replayAttr =
			this.originPlayerConfig && replay !== this.originPlayerConfig.replay
				? `data-qplayer-repeat="${replay}" `
				: '';
		const showDownloadButtonAttr =
			this.originPlayerConfig && showDownloadButton !== this.originPlayerConfig.showDownloadButton
				? `data-qplayer-download="${showDownloadButton}" `
				: '';
		const showOpenInNewWindowAttr =
			this.originPlayerConfig && showOpenInNewWindow !== this.originPlayerConfig.showOpenInNewWindow
				? `data-qplayer-openInNewWindow="${showOpenInNewWindow}" `
				: '';
		const uniqueFrameAttr = uniqueFrame ? `data-qplayer-unique-frame="${uniqueFrame}"` : '';
		const softFullscreenAttr = softFullscreen ? 'data-qplayer-inline="off" ' : '';
		const mediaType =
			placementType && placementType.toUpperCase() === 'MEDIAS'
				? 'media'
				: placementType.toUpperCase() === 'SCENARIOS'
				? 'scenario'
				: 'playlist';
		const languageAttr =
			language && this.originPlayerConfig && language !== this.originPlayerConfig.language
				? `data-qplayer-language="${language}"`
				: '';
		const eventLinkAttr = eventLink && eventLink.trim() ? `data-qplayer-event-link="${eventLink.trim()}" ` : '';

		if (isUsingTheoPlayer) {
			return (
				`<div ${placementType !== 'playlist' ? 'bonnier-player-media-id' : 'bonnier-player-playlist-id'}="${
					mediaDetails.id
				}" ` +
				`account="${defaultAccountId}" ` +
				(autostart ? `autoplay ` : '') +
				`backdrop ` +
				(replay ? `replay ` : '') +
				(showDownloadButton ? `download ` : '') +
				(muteAtStart ? `muted ` : '') +
				`style="width:${fixedSize.width}px;height:${fixedSize.height}px"/>` +
				`<script type="text/javascript" src="${
					selectedPlayerConfig.layouts[0]?.playerStyling?.script ?? DEFAULT_THEO_PLAYER_EMBED
				}" async ></script>`
			);
		}

		if (isUsingBonnierNews) {
			return `<div class="bn-video-player" data-api-url="${readPublicApiEndpointV1}${defaultAccountId}/${mediaType}s/${mediaDetails.id}"></div>`;
		}

		const isAlphaEnv = envName === 'alpha' || envName === 'development';
		const isBetaEnv = envName === 'beta';
		const isStoryPreset = selectedPlayerConfig?.id?.toLowerCase().includes(publicConfigIds.Story.toLowerCase());
		// video ratio 16:9, set padding-bottom 56.25%; video ratio 1:1, set padding-bottom 100%
		const paddingRatio = isStoryPreset ? '177.78%' : '56.25%';

		if (playerSize === 'responsive') {
			return (
				`<div style="position:relative;padding-bottom:${paddingRatio};">` +
				`<div style="position:absolute;top:0;left:0;" ` +
				`title="${title}" ` +
				`data-qplayer-account-id="${defaultAccountId}" ` +
				`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
				`data-qplayer-preset-id="${selectedPlayerConfig.id}" ` +
				`${isAlphaEnv ? 'data-qplayer-alpha="true" ' : ''}` +
				`${isBetaEnv ? 'data-qplayer-beta="true" ' : ''}` +
				`${languageAttr}` +
				`${softFullscreenAttr}` +
				`${autostartAttr}` +
				`${showSocialSharingAttr}` +
				`${muteAtStartAttr}` +
				`${replayAttr}` +
				`${uniqueFrameAttr}` +
				`${showDownloadButtonAttr}` +
				`${showOpenInNewWindowAttr}` +
				`${eventLinkAttr}></div>\n` +
				`<script src="${qplayerLoaderUrl}"></script>` +
				`</div>`
			);
		}

		return (
			`<div style="width:${fixedSize.width}px;height:${fixedSize.height}px" ` +
			`title="${title}" ` +
			`data-qplayer-thumbnail-width="${fixedSize.width}" ` +
			`data-qplayer-thumbnail-height="${fixedSize.height}" ` +
			`data-qplayer-account-id="${defaultAccountId}" ` +
			`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
			`data-qplayer-preset-id="${selectedPlayerConfig.id}" ` +
			`${isAlphaEnv ? 'data-qplayer-alpha="true" ' : ''}` +
			`${isBetaEnv ? 'data-qplayer-beta="true" ' : ''}` +
			`${languageAttr}` +
			`${softFullscreenAttr}` +
			`${autostartAttr}` +
			`${showSocialSharingAttr}` +
			`${muteAtStartAttr}` +
			`${replayAttr}` +
			`${uniqueFrameAttr}` +
			`${showDownloadButtonAttr}` +
			`${eventLinkAttr}></div>\n` +
			`<script src="${qplayerLoaderUrl}"></script>`
		);
	};

	/** <qplayer-reels-embed>. Only the settings that differ from the preset are written out. */
	getReelsEmbedCode = () => {
		const { selectedPlayerConfig, muteAtStart, language, showSocialSharing, reelsFeedId } = this.state;
		const { reelsUrlPattern, reelsGalleryUrl, reelsAdTag, reelsAdInterval, reelsAdSkipAfter } = this.state;
		const { mediaDetails, defaultAccountId } = this.props;
		if (!selectedPlayerConfig) {
			return '';
		}

		const title = mediaDetails?.metadata?.title;
		const languageAttr =
			language && this.originPlayerConfig && language !== this.originPlayerConfig.language
				? `data-qplayer-language="${language}" `
				: '';
		const muteAtStartAttr =
			this.originPlayerConfig && muteAtStart !== this.originPlayerConfig.muteAtStart
				? `data-qplayer-mute="${muteAtStart}" `
				: '';
		// The feed draws a share button, so this one reaches it; the other toggles do not.
		const showSocialSharingAttr =
			this.originPlayerConfig && showSocialSharing !== this.originPlayerConfig.showSocialSharing
				? `data-qplayer-sharing="${showSocialSharing}" `
				: '';
		// Empty writes nothing, so the preset keeps deciding.
		const optional = (name, value) => {
			const trimmed = String(value ?? '').trim();
			return trimmed ? `data-qplayer-${name}="${trimmed}" ` : '';
		};

		return (
			`<qplayer-reels-embed title="${title}" ` +
			`data-qplayer-id="${reelsFeedId}" ` +
			`data-qplayer-account-id="${defaultAccountId}" ` +
			`data-qplayer-playlist-id="${mediaDetails.id}" ` +
			`data-qplayer-preset-id="${selectedPlayerConfig.id}" ` +
			`${languageAttr}` +
			`${muteAtStartAttr}` +
			`${showSocialSharingAttr}` +
			`${optional('reels-url', reelsUrlPattern)}` +
			`${optional('gallery-url', reelsGalleryUrl)}` +
			`${optional('story-ad-tag', reelsAdTag)}` +
			`${optional('story-ad-interval', reelsAdInterval)}` +
			`${optional('story-ad-skip-after', reelsAdSkipAfter)}></qplayer-reels-embed>\n` +
			`<script src="${qplayerWebComponentLoaderUrl}"></script>\n\n` +
			`<!-- Example trigger. The embed draws nothing until something opens it. -->\n` +
			`<button onclick="QplayerReels.openReels({ qplayerId: '${reelsFeedId}' })">Open the reel</button>\n` +
			`<!-- Or mark your own thumbnails: any element with data-qplayer-media-id opens the feed at that clip. -->`
		);
	};

	getQplayerWidgetDivEmbedCodeV1_1 = () => {
		const { mediaDetails, defaultAccountId, placementType } = this.props;
		const { selectedPlayerConfig } = this.state;

		const mediaType =
			placementType && placementType.toUpperCase() === 'MEDIAS'
				? 'media'
				: placementType.toUpperCase() === 'SCENARIOS'
				? 'scenario'
				: 'playlist';

		return (
			`<qplayer-widget-embed ` +
			`data-qplayer-id="qplayer-widget-${generateRandomId()}" ` +
			`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
			`data-qplayer-account-id="${defaultAccountId}" ` +
			`data-qplayer-preset-id="${selectedPlayerConfig?.id ?? 'Story'}" ` +
			`></qplayer-widget-embed>\n` +
			`<script src="${qplayerWebComponentLoaderUrl}"></script> `
		);
	};

	getQplayerWidgetDivEmbedCode = () => {
		const { mediaDetails, defaultAccountId, placementType } = this.props;

		const mediaType =
			placementType && placementType.toUpperCase() === 'MEDIAS'
				? 'media'
				: placementType.toUpperCase() === 'SCENARIOS'
				? 'scenario'
				: 'playlist';

		return (
			`<div ` +
			`data-qplayer-widget-${mediaType}-id="${mediaDetails.id}" ` +
			`data-qplayer-widget-account-id="${defaultAccountId}" ` +
			`data-qplayer-widget-config-id="Story" ` +
			`> ` +
			`<script src="https://play2.qbrick.com/qplayer/loader/qplayer-widget.min.js"></script> ` +
			`</div>`
		);
	};

	renderInformationSection = (_) => {
		const { t, mediaDetails, liveMediaChannelId, videoWidth } = this.props;
		const { videos } = this.state;
		const video = videos && videos.length > 0 ? videos[0] : undefined;
		return (
			<InformationSection
				t={t}
				mediaDetails={mediaDetails}
				liveMediaChannelId={liveMediaChannelId}
				width={videoWidth}
				codec={video?.codec}
				format={video?.mimeType}
				resolution={video ? `${video.width} x ${video.height}` : undefined}
			/>
		);
	};

	render() {
		const {
			t,
			defaultAccountId,
			mediaDetails,
			videoWidth: videoWidthProps,
			videoHeight: videoHeightProps,
			playerConfigurationId,
			scenario,
			placementType,
			breadCrumbHeight,
			embedOnly,
			hide,
		} = this.props;
		const {
			selectedPlayerConfig,
			autostart,
			replay,
			muteAtStart,
			showSocialSharing,
			softFullscreen,
			showDownloadButton,
			showOpenInNewWindow,
			isQuickEditShown,
		} = this.state;

		const isUsingTheoPlayer = selectedPlayerConfig && selectedPlayerConfig.id === THEO_PLAYER_PRESET_ID;
		const mediaType = scenario
			? 'scenario'
			: placementType && placementType.toUpperCase() === 'MEDIAS'
			? 'media'
			: placementType.toUpperCase() === 'SCENARIOS'
			? 'scenario'
			: 'playlist';

		if (hide) {
			return null;
		}

		const isStoryPreset = selectedPlayerConfig?.id?.toLowerCase().includes(publicConfigIds.Story.toLowerCase());
		const videoWidth = isStoryPreset ? defaultStoryVideoWidth : videoWidthProps;
		const videoHeight = isStoryPreset ? defaultStoryVideoHeight : videoHeightProps;

		const isAlphaEnv = envName === 'alpha' || envName === 'development';
		const isBetaEnv = envName === 'beta';
		return (
			<>
				{isUsingTheoPlayer && (
					<Helmet>
						<script
							id="theo-script-id"
							src={selectedPlayerConfig.layouts[0]?.playerStyling?.script ?? DEFAULT_THEO_PLAYER_EMBED}
							type="text/javascript"
							async="true"
						/>
					</Helmet>
				)}
				<div id="inspectViewLivePlayer" className="player-preview">
					{!embedOnly ? (
						isUsingTheoPlayer ? (
							<div
								dangerouslySetInnerHTML={{
									__html: `<div id='player-preview' bonnier-player-${
										placementType === 'medias' ? 'media' : 'playlist'
									}-id= ${mediaDetails.id}
								account=${defaultAccountId}
								${autostart ? 'autoplay' : ''}
								backdrop
								${replay ? 'replay' : ''}
								${muteAtStart ? 'muted' : ''}
								${showDownloadButton ? 'download' : ''}
								style='width: ${videoWidth}px; height: ${videoHeight}px'/>`,
								}}
							/>
						) : (
							<div className="LivePlayerWrapper">
								<div
									id="player-preview"
									style={{ width: videoWidth + 'px', height: videoHeight + 'px' }}
									{...{ [`data-qplayer-${mediaType}-id`]: mediaDetails.id }}
									data-qplayer-id={mediaDetails.id}
									data-qplayer-account-id={defaultAccountId}
									data-qplayer-preset-id={
										selectedPlayerConfig ? selectedPlayerConfig.id : playerConfigurationId
									}
									data-qplayer-autoplay={autostart}
									data-qplayer-sharing={showSocialSharing}
									data-qplayer-openInNewWindow={showOpenInNewWindow}
									data-qplayer-mute={muteAtStart}
									data-qplayer-repeat={replay}
									data-qplayer-download={showDownloadButton}
									data-qplayer-inline={softFullscreen ? 'off' : 'on'}
									data-qplayer-thumbnail-height={`${videoHeight}px`}
									data-qplayer-thumbnail-width={`${videoWidth}px`}
									data-qplayer-analytics={'off'}
									data-qplayer-alpha={isAlphaEnv ? 'true' : 'false'}
									data-qplayer-beta={isBetaEnv ? 'true' : 'false'}
								/>
							</div>
						)
					) : null}

					<div
						className="player-preview__embed-setting"
						style={
							embedOnly
								? undefined
								: {
										height: `calc(100% - ${videoHeight - (breadCrumbHeight ?? 0)}px)`,
										overflow: 'auto',
										paddingBottom: '24px',
								  }
						}
					>
						{!embedOnly && (
							<div className="player-preview__header">
								{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_PLAYER_INFO_EMBED_SETTING')}
								{this.renderVideoActions()}
							</div>
						)}
						{this.renderPlayerSettingSection()}
						{this.renderEmbedSection()}
						{this.renderReelsSection()}
						{(mediaType === 'media' || mediaType === 'playlist') &&
							this.renderPortalSharingSection(mediaType)}
						{!embedOnly && this.renderInformationSection()}
					</div>
					<QbrickEditorDialog
						open={isQuickEditShown}
						onClose={() => {
							this.setState({ isQuickEditShown: false });
						}}
					/>
				</div>
			</>
		);
	}
}

InspectPlayerPreviewArea.propTypes = {
	mediaId: PropTypes.string,
	onPlayerConfigChange: PropTypes.func,
};

const mapStateToProps = ({
	apps,
	session,
	publish,
	breadCrumbReducer,
	navReducer,
	inspectScreenReducer,
	interactTimelineReducer,
	interactElementsReducer,
	speechToText,
}) => ({
	apps: apps.apps,
	open: navReducer.open,
	loading: publish.loading,
	interactLoading: interactElementsReducer.loading,
	username: session.username,
	accounts: session.accounts,
	isLoggedIn: session.isLoggedIn,
	routeAfterSave: publish.routeAfterSave,
	defaultAccountId: session.defaultAccountId,
	locationArray: breadCrumbReducer.locationArray,
	isInspectScreenModified: publish.isInspectScreenModified,
	userPermissions: session.userPermissions,
	playerConfigId: inspectScreenReducer.playerConfigId,
	videoPlayerMuted: inspectScreenReducer.videoPlayerMuted,
	isInteractScreenModified: interactTimelineReducer.isInteractScreenModified,
	isMountedSubtitleUpdated: speechToText.isMountedSubtitleUpdated,
	currentComponentKey: navReducer.currentComponentKey,
	refreshMediasIds: publish.refreshMediasIds,
	refreshScenario: publish.refreshScenario,
});

const mapDispatchToProps = (dispatch) => ({
	updateScreenName: (name) => dispatch(updateScreenName(name)),
	sendMediaScreenChanged: (_) => dispatch(sendMediaScreenChanged()),
	showNotification: (message) => dispatch(showNotification(message)),
	sendMediaScreenUnChanged: (_) => dispatch(sendMediaScreenUnChanged()),
	clearBreadCrumbLocationArray: (_) => dispatch(clearBreadCrumbLocationArray()),
	changeRouteAfterInspectScreen: (route) => dispatch(changeRouteAfterInspectScreen(route)),
	updateBreadCrumbLocationArray: (key, location) => dispatch(updateBreadCrumbLocationArray(key, location)),
	deleteRestrictionRule: (accountId, restrictionId) => dispatch(deleteRestrictionRule(accountId, restrictionId)),
	getMediaQueryDetails: (accId, mediaId, mediaName) => dispatch(getMediaQueryDetails(accId, mediaId, mediaName)),
	shareThePostOnSocialMedia: (accId, mediaId, post) => dispatch(shareThePostOnSocialMedia(accId, mediaId, post)),
	createNewRestrictionRule: (accountId, restrictionId, body) =>
		dispatch(createNewRestrictionRule(accountId, restrictionId, body)),
	saveInspectScreenDetails: (accountId, mediaId, mediaName, body) =>
		dispatch(saveInspectScreenDetails(accountId, mediaId, mediaName, body)),
	updateExistingRestrictionRule: (accountId, restrictionId, body) =>
		dispatch(updateExistingRestrictionRule(accountId, restrictionId, body)),
	applyRestrictionRuleOnMedia: (accountId, mediaName, mediaId, restrictionId) =>
		dispatch(applyRestrictionRuleOnMedia(accountId, mediaName, mediaId, restrictionId)),
	deleteRestrictionRuleOnMedia: (accountId, mediaName, mediaId, restrictionId) =>
		dispatch(deleteRestrictionRuleOnMedia(accountId, mediaName, mediaId, restrictionId)),
	setSelectedApp: (app) => dispatch(setSelectedApp(app)),
	clearInspectScreenStorage: () => dispatch(clearInspectScreenStorage()),
	updateMenuKeys: (key) => dispatch(updateMenuKeys(key)),
	addMediaDetails: (details) => dispatch(addMediaDetails(details)),
	setIsMountedSubtitleUpdated: (mountedSubUpdate) => dispatch(setIsMountedSubtitleUpdated(mountedSubUpdate)),
	updateCurentComponentKey: (key) => dispatch(updateCurentComponentKey(key)),
	showMessage: (stackMessage, type) => dispatch(showMessage(stackMessage, type)),
	fetchPlayerEmbedConfiguration: (accId) => dispatch(fetchPlayerEmbedConfiguration(accId)),
	setSidePlayerConfigId: (value) => dispatch(setSidePlayerConfigId(value)),
	loadPlayerConfiguration: (accountId) => dispatch(loadPlayerConfiguration(accountId)),
	getAccountSettings: (accountId) => dispatch(getAccountSettings(accountId)),
	loadMediasByQuery: (accountId, mediaName, query) => dispatch(loadMediasByQuery(accountId, mediaName, query)),
	setMediaForTrimming: (media) => dispatch(setMediaForTrimming(media)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(InspectPlayerPreviewArea);
